import React, { Component } from 'react';
import { Button, Table, Form, Divider, message, Select } from 'antd';
import axios from '../../service/index'
import './userfeedback.less'
const { Option } = Select;
class AuditManagement extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectValue: false,
			visible: false,
			lableListData: [],
			total: 0,
			name: '',
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			labelName: '',
			labelId: null,
			ids: '',
			optionList: [],
			columns: [
				{
					title: '电话号码',
					width: '180px',
					dataIndex: 'phone',
					key: 'phone',
					align: 'center',
				},
				{
					title: '反馈内容',
					dataIndex: 'msg',
					key: 'msg',
					align: 'center',
				},
				{
					title: '反馈时间',
					dataIndex: 'createTime',
					key: 'createTime',
					width: '180px',
					align: 'center'
				},
				{
					title: '操作',
					key: 'operation',
					align: 'center',
					width: '180px',
					render: (record) => <div>
						{record.status === true ? '已处理' : <span style={{ marginRight: '15px', color: '#277FFF', cursor: 'pointer' }} onClick={() => {
							const ids = []
							ids.push({id: record.id, status: true})
							axios.post('feedbackController/updateStatus', ids).then(res => {
								if (res.data.code === '200') {
									message.success('处理成功')
									this.lableList()
								} else {
									message.error(res.data.msg)
								}
							})

						}}>未处理</span>}
					</div>
				},
			]
		}
	}
	componentDidMount() {
		this.lableList()
	}
	showModal = (e) => {
		this.setState({
			visible: true
		})

	}

	lableList = () => {
		axios.post('feedbackController/getFeedbackList', {
			...this.state.searchData,
			status: this.state.selectValue,

		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					lableListData: res.data.data.list,
					total: res.data.data.total
				})

			}
		})
	}
	delLable(id) {
		axios.get(`labelController/del/${id}`).then(res => {
			if (res.data.code === '200') {
				message.success('删除成功')
				this.lableList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false
		})
	};
	batchPass() {
		const ids = []
		this.state.ids.forEach(item => {
			ids.push({id: item, status: true})
		});
		axios.post('feedbackController/updateStatus', ids).then(res => {
			if (res.data.code === '200') {
				message.success('批量操作处理成功')
				this.lableList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	render() {
		const { lableListData, columns, total, show } = this.state
		const pagination = {
			showSizeChanger: true,
			total: total,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.lableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.lableList(searchData)
			},
		}
		const rowSelection = {
			onChange: (selectedRowKeys, selectedRows) => {
				this.setState({
					ids: selectedRowKeys
				})
			},
			onSelect: (record, selected, selectedRows) => {
				this.setState({
					show: selected
				})
			},
			onSelectAll: (selected, selectedRows, changeRows) => {
				this.setState({
					show: selected
				})
			},
			getCheckboxProps: (record) => ({
				disabled: record.status === true,
			})
		};
		return (
			<div>
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>用户反馈</span>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<div>
            <Select  placeholder="处理状态" size={'large'} value={this.state.selectValue}  allowClear style={{ width: 260, height: '40px', marginRight: '20px' }} onChange={(value)=>{
							this.setState({
								selectValue: value
							})
						}}>
							<Option value="">全部</Option>
							<Option value={true}>已处理</Option>
							<Option value={false}>未处理</Option>
						</Select>
						<Button className='my-button-primary' type='primary'  style={{marginRight: '20px'}} onClick={() => {
							this.lableList()
						}}>搜索</Button>
						<span className="my-button-txt" onClick={() => {
							this.setState({
								selectValue: false,
							},()=>{
								this.lableList()
							})
						}}>重置</span>
					</div>
					{show && <div>
						<span className="my-button-txt" onClick={() => {
							this.batchPass()
						}}>批量处理</span>
					</div>}
				</div>
				<Table rowSelection={rowSelection} dataSource={lableListData} columns={columns} rowKey={record => record.id} pagination={pagination} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}/>

			</div>
		)
	}

};

export default Form.create()(AuditManagement)
